import { TreeListColumnProps } from '@progress/kendo-react-treelist';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useWindowSize from 'src/hooks/useWindowSize';
import ActionCell from 'src/sections/work_area/table_cell/ActionCell';
import ProfileCell from 'src/sections/work_area/table_cell/ProfileCell';

const useUserCompaniesColumns = () => {
  const { t } = useTranslation();
  const { width } = useWindowSize();

  // Calculate grid width based on 55% of screen width (UserCompanies container width)
  // Account for border (2px total) and internal spacing to prevent horizontal overflow
  // Using similar pattern to useProductColumns but adjusted for 55% container
  const gridWidth = useMemo(() => Math.round(width * 0.55 - 4), [width]);

  // Helper function to calculate width based on percentage
  const setPercentage = useMemo(
    () => (percentage: number) => Math.round((gridWidth / 100) * percentage),
    [gridWidth]
  );

  const columns: TreeListColumnProps[] = useMemo(
    () => [
      {
        field: 'userNameAndRole',
        title: t('userNameAndRole'),
        width: setPercentage(55),
        expandable: true,
      },
      {
        field: 'spendingLimit',
        title: t('poSpendingLimit'),
        width: setPercentage(20),
        className: 'right-justify',
        headerClassName: 'right-justify',
      },
      {
        field: 'profile',
        title: t('profile'),
        width: setPercentage(12.5),
        sortable: false,
        cell: ProfileCell,
      },
      {
        field: 'action',
        title: t('Action'),
        sortable: false,
        width: Math.max(setPercentage(12.5), 100),
        cell: ActionCell,
      },
    ],
    [setPercentage, t]
  );

  return columns;
};

export default useUserCompaniesColumns;
